import React, { useEffect, useState } from "react";
import "./styles.scss";
import { useMenuHubApi } from "../../api/menuHub";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faChevronRight, faPencil, faRotateRight, faSearch, faTrash, faUser } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";


interface Usuario {
    usuario: string;
    email: string;
    loginTasy: string;
}

interface Paginacao {
    totalCount: string;
    totalPages: string;
    totalItemsPerPage: string;
    currentPage: string;
    itemsInThePage: string;
    isLastPage: string;
    hasNextPage: string;
    hasPreviousPage: string;
}

const AdminPanel: React.FC = () => {
    const [busca, setBusca] = useState("");
    const [usuarios, setUsuarios] = useState<Usuario[]>([]);
    const [paginacao, setPaginacao] = useState<Paginacao | null>(null);
    const [actualPage, setActualPage] = useState(0);
    const [showModal, setShowModal] = useState(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [userToDelete, setUserToDelete] = useState<Usuario | null>(null);

    const { getProfile, deleteUser } = useMenuHubApi();
    const navigate = useNavigate();

    const fetchUsuarios = async () => {
        try {
            const response = await getProfile(busca, 10, actualPage);
            setUsuarios(response?.usuarios ?? []);
            setPaginacao(response?.pagination ?? null);
        } catch (err) {
            console.error("Erro ao buscar usuários:", err);
            setUsuarios([]);
        }
    };

    const openDeleteModal = (user: Usuario) => {
        setUserToDelete(user);
        setShowModal(true);
    };

    const closeDeleteModal = () => {
        setUserToDelete(null);
        setShowModal(false);
    };

    const confirmDelete = async () => {
        if (!userToDelete) return;

        try {
            setLoading(true);
            await deleteUser(userToDelete.email);
            await fetchUsuarios();
        } catch (err) {
            console.error("Erro ao deletar usuário", err);
        } finally {
            setLoading(false);
            closeDeleteModal();
        }
    };


    useEffect(() => {
        fetchUsuarios();
    }, [actualPage, busca]);

    const redefinir = () => {
        setBusca("");
        setActualPage(0);
    };

    const handlePrimeira = () => setActualPage(0);

    const handleAnterior = () => {
        if (actualPage > 0) setActualPage(actualPage - 1);
    };

    const handleProxima = () => {
        if (
            paginacao &&
            !JSON.parse(paginacao.isLastPage.toLowerCase()) &&
            actualPage + 1 < parseInt(paginacao.totalPages)
        ) {
            setActualPage(actualPage + 1);
        }
    };

    const handleUltima = () => {
        if (paginacao)
            setActualPage(parseInt(paginacao.totalPages) - 1);
    };

    return (
        <div className="gerenciamento-acessos">
            <div className="header">
                <h2>Gerenciamento de acessos</h2>
                <button className="novo-usuario" onClick={() => navigate("/painel-central/add-user")}>+ Novo usuário</button>
            </div>

            <div className="tabela-container show-for-computer">
                <div className="filtros">
                    <div className="campo-busca">
                        <FontAwesomeIcon icon={faSearch} className="icone-busca" style={{ color: "#ED4C52" }} />
                        <input
                            style={{ paddingLeft: "32px" }}
                            type="text"
                            placeholder="Procurar"
                            value={busca}
                            onChange={(e) => {
                                setBusca(e.target.value);
                                setActualPage(0);
                            }}
                        />
                    </div>

                    <button className="redefinir" onClick={redefinir}>
                        <FontAwesomeIcon icon={faRotateRight} /> <p>Redefinir</p>
                    </button>
                </div>

                <table className="tabela">
                    <thead>
                        <tr>
                            <th>Nome</th>
                            <th>E-mail</th>
                            <th>Login Tasy</th>
                            <th>Ações</th>
                        </tr>
                    </thead>
                    <tbody>
                        {usuarios.length > 0 ? (
                            usuarios.map((u, idx) => (
                                <tr key={idx}>
                                    <td>{u.usuario}</td>
                                    <td>{u.email}</td>
                                    <td>{u.loginTasy}</td>
                                    <td style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                                        <div
                                            onClick={() =>
                                                navigate(`/painel-central/add-user/${u.email}?loginTasy=${u.loginTasy || ""}`)
                                            }
                                            style={{ cursor: "pointer" }}
                                        >
                                            <FontAwesomeIcon icon={faPencil} className="to-hover"/></div>

                                        <FontAwesomeIcon
                                            className="to-hover"                                        
                                            style={{ marginLeft: "8px", cursor: "pointer" }}
                                            icon={faTrash}
                                            onClick={() => openDeleteModal(u)}
                                        />

                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={3} style={{ textAlign: "center", padding: "1rem" }}>
                                    Nenhum usuário encontrado.
                                </td>
                            </tr>
                        )}

                    </tbody>
                </table>

                <p className="descricao">
                </p>
            </div>

            <div className="tabela-container show-for-mobile">
                <div className="filtros">
                    <div className="campo-busca">
                        <FontAwesomeIcon icon={faSearch} className="icone-busca" style={{ color: "#ED4C52" }} />
                        <input
                            style={{ paddingLeft: "32px" }}
                            type="text"
                            placeholder="Procurar"
                            value={busca}
                            onChange={(e) => {
                                setBusca(e.target.value);
                                setActualPage(0);
                            }}
                        />
                    </div>

                    <button className="redefinir" onClick={redefinir}>
                        <FontAwesomeIcon icon={faRotateRight} /> <p> Redefinir</p>
                    </button>
                </div>


                <div>
                    {usuarios.length > 0 ? (
                        usuarios.map((u, idx) => (
                            <div key={idx} style={{ border: "1px solid #E4E4E4", padding: "1rem", marginBottom: "4px", borderRadius: "8px", backgroundColor: "white" }}>
                                <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                                    <FontAwesomeIcon icon={faUser}></FontAwesomeIcon>
                                    <p style={{ marginLeft: "4px" }}>{u.usuario}</p>
                                </div>
                                <p style={{ color: "#787878", fontSize: "12px" }}>{u.email}</p>
                                <p style={{ color: "#787878", marginTop: "8px", fontSize: "12px" }}>Login: {u.loginTasy}</p>
                            </div>
                        ))
                    ) : (
                        <tr>
                            <td colSpan={3} style={{ textAlign: "center", padding: "1rem" }}>
                                Nenhum usuário encontrado.
                            </td>
                        </tr>
                    )}
                </div>

                <p className="descricao">
                </p>
            </div>

            <div
                className="tabela-container pagination-content"
                style={{
                    backgroundColor: "transparent",
                    border: "none",
                    boxShadow: "none",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    flexDirection: "row"
                }}
            >

                <div style={{ width: "10%" }} className="info">

                </div>

                <div className="paginacao">
                    {paginacao && parseInt(paginacao.totalPages, 10) > 3 && (
                        <span
                            onClick={handlePrimeira}
                            className={actualPage === 0 ? "disabled" : ""}
                        >
                            <FontAwesomeIcon icon="chevron-double-left" /> Primeira
                        </span>
                    )}

                    <span
                        onClick={handleAnterior}
                        className={actualPage === 0 ? "disabled" : ""}
                    >
                        <FontAwesomeIcon icon={faChevronLeft} /> Anterior
                    </span>

                    <span
                        className={actualPage === 0 ? "ativo" : ""}
                        onClick={() => setActualPage(0)}
                    >
                        1
                    </span>

                    {paginacao &&
                        parseInt(paginacao.totalPages, 10) > 2 &&
                        actualPage > 0 &&
                        actualPage < parseInt(paginacao.totalPages) - 1 && (
                            <span className="ativo" onClick={() => setActualPage(actualPage)}>
                                {actualPage + 1}
                            </span>
                        )}

                    {paginacao && parseInt(paginacao.totalPages, 10) > 1 && (
                        <span
                            className={
                                actualPage === parseInt(paginacao.totalPages) - 1 ? "ativo" : ""
                            }
                            onClick={() => setActualPage(parseInt(paginacao.totalPages) - 1)}
                        >
                            {parseInt(paginacao.totalPages)}
                        </span>
                    )}

                    <span
                        onClick={handleProxima}
                        className={
                            paginacao && JSON.parse(paginacao.isLastPage.toLowerCase())
                                ? "disabled"
                                : ""
                        }
                    >
                        Próxima <FontAwesomeIcon icon={faChevronRight} />
                    </span>

                    {paginacao && parseInt(paginacao.totalPages, 10) > 3 && (
                        <span
                            onClick={handleUltima}
                            className={
                                paginacao && JSON.parse(paginacao.isLastPage.toLowerCase())
                                    ? "disabled"
                                    : ""
                            }
                        >
                            Última <FontAwesomeIcon icon="chevron-double-right" />
                        </span>
                    )}
                </div>


                <div className="info" style={{ width: "10%" }}>
                    {paginacao
                        ? `${paginacao.itemsInThePage} de ${paginacao.totalCount} itens no total`
                        : "Carregando..."}
                </div>
            </div>
            {showModal && (
                <div className="modal-overlay">
                    <div className="modal">
                        <h3>Confirmar exclusão</h3>

                        <p>
                            Tem certeza que deseja excluir o usuário
                            <strong> {userToDelete?.email}</strong>?
                        </p>

                        <div className="modal-actions">
                            <button className="btn-cancelar" onClick={closeDeleteModal}>
                                Cancelar
                            </button>

                            <button
                                className="btn-excluir"
                                onClick={confirmDelete}
                                disabled={loading}
                            >
                                {loading ? "Excluindo..." : "Excluir"}
                            </button>
                        </div>
                    </div>
                </div>
            )}

        </div >
    );
};

export default AdminPanel;
